<template>
  <div class="accordion" id="demographicAccordion">
    <draggable v-model="demographicQuestionsValues">
      <transition-group>
        <div
          v-for="(question, index) in demographicQuestionsValues"
          :key="'DemographicQuestion' + index + index"
        >
          <div class="accordion-item">
            <h2
              class="accordion-header py-3"
              :id="'headingDemographic' + index"
            >
              <span class="row align-items-center g-0">
                <span class="question-no text-center col-1"
                  >Q{{ 1 + index }}</span
                >

                <span class="col-10">
                  <span
                    v-if="
                      !question.localizations['EN'].description.includes('${')
                    "
                    class="question-text mb-0"
                    v-html="question.localizations['EN'].description"
                  ></span>
                  <span v-else class="question-text mb-0 d-flex">
                    <span class="me-2"
                      >{{
                        question.localizations["EN"].description.split("${")[0]
                      }}
                    </span>

                    <placeholder
                      :question="question.localizations['EN'].description"
                      :question-index="index"
                    ></placeholder>

                    <span class="ms-2"
                      >{{
                        question.localizations["EN"].description.split("}")[1]
                      }}
                    </span>
                  </span>
                </span>

                <span class="col-1">
                  <button
                    class="accordion-button collapsed w-auto"
                    type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#collapseCustom' + index"
                    aria-expanded="true"
                    :aria-controls="'collapseCustom' + index"
                  ></button>
                </span>
              </span>
            </h2>
            <div
              :id="'collapseCustom' + index"
              class="accordion-collapse collapse"
              :aria-labelledby="'headingDemographic' + index"
              data-bs-parent="#demographicAccordion"
            >
              <div class="accordion-body p-0 g-0 row">
                <div>
                  <ul class="list-unstyled g-0 mb-2 offset-1 col-11 row">
                    <li
                      v-for="(option, choicesIndex) of question.choices"
                      :key="'answers' + choicesIndex"
                      class="mb-4 answers col-4"
                      v-html="option.localizations['EN'].localizedChoice"
                    ></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="controls d-flex justify-content-end px-4">
              <button
                class="border-0 text-capitalize p-2 m-2"
                @click="deleteQuestion(question.id)"
              >
                <img
                  alt="close"
                  width="35"
                  class="mx-1 img-fluid"
                  src="@/assets/images/set-question/x.svg"
                />
                delete question
              </button>
            </div>
          </div>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import Placeholder from "./placeholder";

export default {
  name: "CustomQuestionBody",
  components: { Placeholder },
  computed: {
    demographicQuestionsValues: {
      get() {
        return this.$store.getters[
          "surveyJourney/demographicQuestionsOfCurrentSurvey"
        ];
      },
      set(value) {
        this.$store.commit("surveyJourney/updateList", value);
      },
    },
  },
  methods: {
    deleteQuestion(id) {
      this.$store.dispatch("surveyJourney/deleteDemographicQuestion", { id });
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion-header {
  @extend %font-16-regular;
  color: $color-white;
  font-weight: $font-weight-semiBold;
}

.controls {
  border-top: $border-grey-60;

  button {
    background-color: unset;
    font-size: $font-size-16;
    line-height: $line-height-22;
    font-weight: $font-weight-regular;
    letter-spacing: 0;
    color: $color-white;
  }

  img {
    width: 2.1875rem;
  }
}
</style>
